// extracted by mini-css-extract-plugin
module.exports = {"blog__detail__content":"styles_blog__detail__content__RmFgM","wrapper":"styles_wrapper__G-k8d"};